import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../../sdk/src/components/ibase-page/ibase-page.component';
import {OO8ConnectorCRUDComponent} from '../../../components/oo8-connector-crud/oo8-connector-crud.component';

@Component({
    selector: 'app-ga-oo8-connectors-page',
    templateUrl: './oo8-connectors-page.component.html',
    imports: [PrimeNgImportsModule, OO8ConnectorCRUDComponent, OO8ConnectorCRUDComponent]
})
export class GOO8ConnectorsPage extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
